import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';

const workBoardPage = PageBlueprint.make({
  params: {
    path: '/studio-workboard',
    title: 'Work Board',
    icon: <ViewColumnIcon />,
    loader: () => import('./WorkBoardPage').then(m => <m.WorkBoardPage />),
  },
});

/** The Work Board frontend plugin — read-only Epic → Feature → Task list sourced from the real
 * Control Plane. First slice; create/dispatch actions land in a follow-up slice. */
export const studioWorkboardPlugin = createFrontendPlugin({
  pluginId: 'studio-workboard',
  title: 'Work Board',
  icon: <ViewColumnIcon />,
  extensions: [workBoardPage],
});

export default studioWorkboardPlugin;
